import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

export function FullscreenSlideTemplate({ display, controls, slots }: SubTemplateProps) {
  const media = display.permissions.canViewContent && !display.access.isContentLocked
    ? display.media.primaryAttachment
    : undefined
  const mediaSrc = media?.src || media?.thumbSrc
  return (
    <>
      <section className={`md-subs-fullscreen-row relative flex min-h-screen flex-col items-center justify-center overflow-hidden border-b border-white/10 bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] p-[60px] text-center text-white transition hover:from-[#16213e] hover:via-[#0f3460] hover:to-[#e94560]${display.isChecked ? ' md-subs-fullscreen-row--checked from-[#e94560] to-[#0f3460]' : ''}`}>
        {mediaSrc ? <img className="absolute inset-0 h-full w-full object-cover opacity-40" src={mediaSrc} alt={media.title || media.filename || display.title} /> : null}
        <div className="md-subs-fullscreen-title relative z-[1] max-w-4xl text-4xl font-semibold leading-tight [&_.md-sub-title-link]:text-white">{controls.content.title}</div>
        <div className="md-subs-fullscreen-text relative z-[1] mt-6 max-w-3xl text-lg leading-[1.5] text-white/85 [&_.md-sub-text]:whitespace-normal [&_.md-sub-text]:text-white/85">{controls.content.text}</div>
        <div className="md-subs-fullscreen-meta relative z-[1] mt-8 flex flex-wrap justify-center gap-4 text-sm text-white/70">
          {controls.content.time}
          {controls.links.answers}
          {controls.links.submsges}
          {controls.actions.check}
          {controls.actions.favorite}
          {controls.actions.quickReply}
        </div>
      </section>
      {slots.allChildren}
    </>
  )
}
